<template>
  <div class="page-wrapper coach-content-wrapper">
    <div class="container">
      <div class="back-to-profile-text">
        <div
          class="d-flex place-items-center"
          @click="handleBackClick"
          v-if="!isOwner"
        >
          <a-icon type="arrow-left" />
          <span class="margin-l-1">Back to profile</span>
        </div>
      </div>
      <div class="content">
        <div class="row">
          <BaseLoading  :spinning="videosLoading">
            <div class="col-md-12 coach-content-aligment videos-form-wrap">
              <div
                class="d-flex justify-center container search-content heading text-uppercase"
              >
                <h2 class="college-name">{{ college.collegeName }}</h2>
                <h2 class="form-title">
                  All Videos
                </h2>
              </div>
              <BaseVideosListing :videos="videos" />
            </div>
          </BaseLoading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const STORE_KEY = "collegeStore";

export default {
  created() {
    this.dispatcher();
  },
  computed: {
    ...mapGetters({
      videos: `${STORE_KEY}/videos`,
      videosLoading: `${STORE_KEY}/videosLoading`,
      college: `${STORE_KEY}/college`
    }),
    collegeId() {
      return this.$route.params.id || localStorage["college-id"];
    },
    hideButton() {
      return (
        localStorage["college-id"] ===
        (this.$route.params.id || this.college.id)
      );
    },
    isOwner() {
      return this.collegeId === localStorage["college-id"];
    }
  },
  methods: {
    async dispatcher() {
      await this.$store.dispatch(`${STORE_KEY}/getVideos`, {
        id: this.collegeId,
        limit: 18,
        page: 1
      });
      await this.$store.dispatch(`${STORE_KEY}/getCollege`, {
        id: this.collegeId
      });
    },
    handleBackClick() {
      this.$router.push(
        `/${this.$route.params.profileId}/college_profile/${this.$route.params.id}/summary`
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.college-name {
  padding-left: 7px;
  border-right: solid 2px #d23129;
  margin-right: 10px !important;
  padding-right: 10px;
}
</style>
